import { useEffect, useState } from "react";
import CareerServicesCurriculumRightCard from "./CareerServicesCurriculumRightCard";
import CareerServicesCurriculumRightCardNew from "./CareerServicesCurriculumRightCardNew";

function CareerServicesCurriculumLeftCardNew({ id, title, description, topices, handleClick, width, activeCurriculum }) {
  const [minusIcon, setMinusIcon] = useState(false)
  const [leftArrorIcon, setLeftArrorIcon] = useState(false)

  useEffect(() => {
    if (width < 768 && activeCurriculum?.id === id){
      setMinusIcon(false)
      setLeftArrorIcon(true)
    } else {
      setMinusIcon(true)
      setLeftArrorIcon(false)
    }  
  }, [id, width, activeCurriculum])

  return (
    <>
    <div className="row card-wrapper" onClick={() =>handleClick({id, title, description, topices})}>
      <div className="col-1 number d-flex justify-content-center align-items-center">
        {id}
      </div>
      <div className="col-10 content text-left">
        <h3 class="view" style={{ fontSize: '14px' }}>{title}</h3>
        <p>{description}</p>
      </div>
      <div className="col-1 icon d-flex align-items-center">
        <svg className={leftArrorIcon && 'd-none'} stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path></svg>
        <svg className={minusIcon && 'd-none'} stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="text-white md:hidden" xmlns="http://www.w3.org/2000/svg"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
      </div>
    </div>
    <div className={`${width > 767 || activeCurriculum.id !== id ? 'd-none' : ''}`}>
      <CareerServicesCurriculumRightCardNew {...activeCurriculum?.topices} />
    </div>
    </>
  );
}
export default CareerServicesCurriculumLeftCardNew;
